<script setup lang="ts">
import { computed } from 'vue';
import { hueOf, initials } from '@/lib/format';

const props = defineProps<{ name: string | null | undefined; size?: number }>();
const style = computed(() => {
  const h = hueOf(props.name ?? '?');
  const s = props.size ?? 26;
  return {
    width: `${s}px`,
    height: `${s}px`,
    fontSize: `${Math.round(s * 0.4)}px`,
    background: `hsl(${h} 55% 45% / 0.22)`,
    color: `hsl(${h} 70% 72%)`,
    borderColor: `hsl(${h} 55% 50% / 0.35)`,
  };
});
</script>

<template>
  <span class="avatar" :style="style" :title="name ?? ''">{{ initials(name) }}</span>
</template>

<style scoped>
.avatar {
  display: inline-grid;
  place-items: center;
  border-radius: 50%;
  border: 1px solid;
  font-weight: 600;
  flex-shrink: 0;
  letter-spacing: 0.02em;
}
</style>
